import { render } from "./navigation.vue?vue&type=template&id=816ded9c"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"

import "./navigation.vue?vue&type=style&index=0&id=816ded9c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__